/** @format */

import React from 'react';
import Grid from 'src/ui/library/Grid/Grid';
import intl from 'react-intl-universal';
import PercentageCircle from 'src/ui/library/PercentageCircle';
import QuestionnaireTopHeader from './QuestionnaireTopHeader';
import QuestionnaireSectionItemsPres from './QuestionnaireSectionItemsPres';
import { ActionsBarContainer } from 'src/ui/features/Questionnaire/containers';
import ServiceSpinner from 'src/ui/library/ServiceSpinner';
import { QUESTIONNAIRE_LANDING_URL } from 'src/constants/constants.js';
import flattenSubMenu from 'src/helpers/flattenSubMenu.js';
import classNames from 'classnames';
import urlParamsMapper from 'src/helpers/urlParamsMapper.js';
import iconTransform from 'src/helpers/iconTransform';
import getCaseDetailPath from 'src/ui/features/Questionnaire/helpers/getCaseDetailPath';
//import { setMenuItemsInSessionStorage } from 'src/helpers';

import { v4 } from 'src/helpers/uuid';

const goldColor = '#f5a623';
const greenColor = '#2eb757';

const parsePercentString = value => parseInt(value, 10);

export const QuestionnaireSectionPres = ({ isWithinCaseDetails, introData, sectionData, push, goBack, match, isMobile, history, location }) => {
  if (!introData || !sectionData) {
    return <ServiceSpinner />;
  }
  const data = sectionData;
  const overallProgress = parsePercentString(introData.overallProgress);
  let { sectionName } = match.params;
  sectionName = (data.sectionNameOldNew && JSON.parse(data.sectionNameOldNew)[sectionName]) || sectionName;
  match.params.sectionName = sectionName;
  const {
    // isDynamic,
    menuName,
    // pageId,
    // pageState,
    sectionProgress,
    subMenu,
    description,
    icon,
    align,
  } = data.menus.filter(m => m.menuName === sectionName)[0] || {};
  let leftSectionItems = [];
  let rightSectionItems = [];
  let flattenedSubMenu = [];
  if (subMenu && subMenu.length) {
    flattenedSubMenu = flattenSubMenu(subMenu);
    const numOfSectionItems = flattenedSubMenu.length;
    const indexOfHalfSectionItem = Math.ceil(numOfSectionItems / 2);
    leftSectionItems = flattenedSubMenu.slice(0, indexOfHalfSectionItem);
    rightSectionItems = flattenedSubMenu.slice(indexOfHalfSectionItem, numOfSectionItems);

    // let sessionMenu = subMenu.map(menu => {
    //   return { pageName: menu.menuName, pageId: menu.pageId };
    // });
    sessionStorage.setItem('qType', introData.questionnaireName);
    // setMenuItemsInSessionStorage(JSON.stringify(sessionMenu));
  }
  const onClose = () => push(getCaseDetailPath(location));

  const alignClass = align === 'C' ? 'center-align' : 'left-align';
  //   const alignClass = "center-align";

  return (
    <div>
      <QuestionnaireTopHeader
        isWithinCaseDetails={isWithinCaseDetails}
        title={menuName}
        onBack={() => push(urlParamsMapper(QUESTIONNAIRE_LANDING_URL, match.params))}
        onClose={onClose}
        data={data}
        overallProgress={overallProgress}
        description={description}
        isMobile={isMobile}
      />
      <article
        className={classNames({
          'questionnaire-section-container': true,
          'is-within-case-details': isWithinCaseDetails,
        })}>
        <header history={history} className="hide-mobile">
          <div className={`header-${alignClass}`}>
            {icon && (
              <span className={'control-icons control-icons-inline ipad-margin'}>
                <span>{iconTransform(icon, !isMobile && { fontSize: 30 })}</span>
              </span>
            )}
            <span>{menuName}</span>
          </div>
          <div className="questionnaire-status">
            <span>
              <PercentageCircle
                color={overallProgress === 100 ? greenColor : goldColor}
                percent={overallProgress}
                radius={35}
                borderWidth={5}>
                <div className="circle-inner-text">
                  <div className={'percentage circle-font-size'}>{overallProgress}%</div>
                  <span className="text">{intl.get('questionnaire.overall')}</span>
                </div>
              </PercentageCircle>
            </span>
          </div>
          <p className={alignClass}>{description}</p>
        </header>
        {isMobile ? (
          <div className="section-items">
            <QuestionnaireSectionItemsPres key={v4()} items={flattenedSubMenu} params={match.params} clickHandler={push} />
          </div>
        ) : (
          <div className="add-side-margins">
            <Grid container spacing={2}>
              <Grid key={v4()} item xs={12} sm={6}>
                <QuestionnaireSectionItemsPres key={v4()} items={leftSectionItems} params={match.params} clickHandler={push} />
              </Grid>
              <Grid key={v4()} item xs={12} sm={6}>
                <QuestionnaireSectionItemsPres key={v4()} items={rightSectionItems} params={match.params} clickHandler={push} />
              </Grid>
            </Grid>
          </div>
        )}
      </article>

      <ActionsBarContainer
        progressTitle={menuName}
        percentProgress={parsePercentString(sectionProgress)}
        onBack={goBack}
        onClose={onClose}
        location={location}
        onSubmitComplete={() => {}}
      />
    </div>
  );
};

export default QuestionnaireSectionPres;
